export { default } from './LazyComponent';
